"use strict";
/*
* Created on Tue Oct 16 2018
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var DataObjectConverter_1 = require("../core/conversions/DataObjectConverter");

var AppModule_1 = require("../core/modules/AppModule");

var PromotionOverviewDTOConverter_1 = require("../promotion/conversions/PromotionOverviewDTOConverter");

var PromotionOverviewDTOConverterImpl_1 = require("../promotion/conversions/PromotionOverviewDTOConverterImpl");

var CoordinatorFlagsConverter_1 = require("./conversions/CoordinatorFlagsConverter");

var CoordinatorFlagsConverterImpl_1 = require("./conversions/CoordinatorFlagsConverterImpl");

var DistributionExceptionConverter_1 = require("./conversions/DistributionExceptionConverter");

var DistributionExceptionConverterImpl_1 = require("./conversions/DistributionExceptionConverterImpl");

var DummyWindowConverter_1 = require("./conversions/DummyWindowConverter");

var DummyWindowConverterImpl_1 = require("./conversions/DummyWindowConverterImpl");

var DummyWindowInfoDTOConverter_1 = require("./conversions/DummyWindowInfoDTOConverter");

var DummyWindowInfoDTOConverterImpl_1 = require("./conversions/DummyWindowInfoDTOConverterImpl");

var DummyWindowSimulationParamsConverter_1 = require("./conversions/DummyWindowSimulationParamsConverter");

var DummyWindowSimulationParamsConverterImpl_1 = require("./conversions/DummyWindowSimulationParamsConverterImpl");

var DummyWindowSimulationSessionConverter_1 = require("./conversions/DummyWindowSimulationSessionConverter");

var DummyWindowSimulationSessionConverterImpl_1 = require("./conversions/DummyWindowSimulationSessionConverterImpl");

var MemberCreditsConverter_1 = require("./conversions/MemberCreditsConverter");

var MemberCreditsConverterImpl_1 = require("./conversions/MemberCreditsConverterImpl");

var PromoDistributionModelConverter_1 = require("./conversions/PromoDistributionModelConverter");

var PromoDistributionModelConverterImpl_1 = require("./conversions/PromoDistributionModelConverterImpl");

var SimulationBigNumberConverter_1 = require("./conversions/SimulationBigNumberConverter");

var SimulationBigNumberConverterImpl_1 = require("./conversions/SimulationBigNumberConverterImpl");

var SimulationStringConverter_1 = require("./conversions/SimulationStringConverter");

var SimulationStringConverterImpl_1 = require("./conversions/SimulationStringConverterImpl");

var SupplierAgreementTransferValidationDTOConverter_1 = require("./conversions/SupplierAgreementTransferValidationDTOConverter");

var SupplierAgreementTransferValidationDTOConverterImpl_1 = require("./conversions/SupplierAgreementTransferValidationDTOConverterImpl");

var WindowActionContextConverter_1 = require("./conversions/WindowActionContextConverter");

var WindowActionContextConverterImpl_1 = require("./conversions/WindowActionContextConverterImpl");

var WindowConverter_1 = require("./conversions/WindowConverter");

var WindowConverterImpl_1 = require("./conversions/WindowConverterImpl");

var WindowCopyResultDTOConverter_1 = require("./conversions/WindowCopyResultDTOConverter");

var WindowCopyResultDTOConverterImpl_1 = require("./conversions/WindowCopyResultDTOConverterImpl");

var WindowDerivedDataConverter_1 = require("./conversions/WindowDerivedDataConverter");

var WindowDerivedDataConverterImpl_1 = require("./conversions/WindowDerivedDataConverterImpl");

var WindowFileConverter_1 = require("./conversions/WindowFileConverter");

var WindowFileConverterImpl_1 = require("./conversions/WindowFileConverterImpl");

var WindowFileOverviewDTOConverter_1 = require("./conversions/WindowFileOverviewDTOConverter");

var WindowFileOverviewDTOConverterImpl_1 = require("./conversions/WindowFileOverviewDTOConverterImpl");

var WindowFilterConverter_1 = require("./conversions/WindowFilterConverter");

var WindowFilterConverterImpl_1 = require("./conversions/WindowFilterConverterImpl");

var WindowItemConverter_1 = require("./conversions/WindowItemConverter");

var WindowItemConverterImpl_1 = require("./conversions/WindowItemConverterImpl");

var WindowItemForecastChangeConverter_1 = require("./conversions/WindowItemForecastChangeConverter");

var WindowItemForecastChangeConverterImpl_1 = require("./conversions/WindowItemForecastChangeConverterImpl");

var WindowItemHistoryTableConverter_1 = require("./conversions/WindowItemHistoryTableConverter");

var WindowItemHistoryTableConverterImpl_1 = require("./conversions/WindowItemHistoryTableConverterImpl");

var WindowItemPlacementConverter_1 = require("./conversions/WindowItemPlacementConverter");

var WindowItemPlacementConverterImpl_1 = require("./conversions/WindowItemPlacementConverterImpl");

var WindowItemPosAttributesConverter_1 = require("./conversions/WindowItemPosAttributesConverter");

var WindowItemPosAttributesConverterImpl_1 = require("./conversions/WindowItemPosAttributesConverterImpl");

var WindowItemPOSPriceRecalcInputConverter_1 = require("./conversions/WindowItemPOSPriceRecalcInputConverter");

var WindowItemPOSPriceRecalcInputConverterImpl_1 = require("./conversions/WindowItemPOSPriceRecalcInputConverterImpl");

var WindowItemProductSuppliersConverter_1 = require("./conversions/WindowItemProductSuppliersConverter");

var WindowItemProductSuppliersConverterImpl_1 = require("./conversions/WindowItemProductSuppliersConverterImpl");

var WindowItemPromoPriceDTOConverter_1 = require("./conversions/WindowItemPromoPriceDTOConverter");

var WindowItemPromoPriceDTOConverterImpl_1 = require("./conversions/WindowItemPromoPriceDTOConverterImpl");

var WindowItemSimulationConverter_1 = require("./conversions/WindowItemSimulationConverter");

var WindowItemSimulationConverterImpl_1 = require("./conversions/WindowItemSimulationConverterImpl");

var WindowItemSimulationSupplierDTOConverter_1 = require("./conversions/WindowItemSimulationSupplierDTOConverter");

var WindowItemSimulationSupplierDTOConverterImpl_1 = require("./conversions/WindowItemSimulationSupplierDTOConverterImpl");

var WindowItemSitesDataConverter_1 = require("./conversions/WindowItemSitesDataConverter");

var WindowItemSitesDataConverterImpl_1 = require("./conversions/WindowItemSitesDataConverterImpl");

var WindowItemTransferValidationDTOConverter_1 = require("./conversions/WindowItemTransferValidationDTOConverter");

var WindowItemTransferValidationDTOConverterImpl_1 = require("./conversions/WindowItemTransferValidationDTOConverterImpl");

var WindowItemUpdateDTOConverter_1 = require("./conversions/WindowItemUpdateDTOConverter");

var WindowItemUpdateDTOConverterImpl_1 = require("./conversions/WindowItemUpdateDTOConverterImpl");

var WindowMoveResultDTOConverter_1 = require("./conversions/WindowMoveResultDTOConverter");

var WindowMoveResultDTOConverterImpl_1 = require("./conversions/WindowMoveResultDTOConverterImpl");

var WindowOverviewDTOConverter_1 = require("./conversions/WindowOverviewDTOConverter");

var WindowOverviewDTOConverterImpl_1 = require("./conversions/WindowOverviewDTOConverterImpl");

var WindowOverviewFilterConverter_1 = require("./conversions/WindowOverviewFilterConverter");

var WindowOverviewFilterConverterImpl_1 = require("./conversions/WindowOverviewFilterConverterImpl");

var WindowProductDetailsConverterImpl_1 = require("./conversions/WindowProductDetailsConverterImpl");

var WindowSearchIndexConverter_1 = require("./conversions/WindowSearchIndexConverter");

var WindowSearchIndexConverterImpl_1 = require("./conversions/WindowSearchIndexConverterImpl");

var WindowSimulationConverter_1 = require("./conversions/WindowSimulationConverter");

var WindowSimulationConverterImpl_1 = require("./conversions/WindowSimulationConverterImpl");

var WindowStatusConverter_1 = require("./conversions/WindowStatusConverter");

var WindowStatusConverterImpl_1 = require("./conversions/WindowStatusConverterImpl");

var WindowTypeConverter_1 = require("./conversions/WindowTypeConverter");

var WindowTypeConverterImpl_1 = require("./conversions/WindowTypeConverterImpl");

var WindowUpdateDTOConverter_1 = require("./conversions/WindowUpdateDTOConverter");

var WindowUpdateDTOConverterImpl_1 = require("./conversions/WindowUpdateDTOConverterImpl");

var WindowImportErrorConverter_1 = require("./import/conversion/WindowImportErrorConverter");

var WindowImportErrorConverterImpl_1 = require("./import/conversion/WindowImportErrorConverterImpl");

var WindowImportResultConverter_1 = require("./import/conversion/WindowImportResultConverter");

var WindowImportResultConverterImpl_1 = require("./import/conversion/WindowImportResultConverterImpl");

var WindowImportWindowIdentificationConverter_1 = require("./import/conversion/WindowImportWindowIdentificationConverter");

var WindowImportWindowIdentificationConverterImpl_1 = require("./import/conversion/WindowImportWindowIdentificationConverterImpl");

var Window_1 = require("./model/Window");

var WindowItem_1 = require("./model/WindowItem");

var WindowItemForecastChange_1 = require("./model/WindowItemForecastChange");

var WindowProductDetails_1 = require("./model/WindowProductDetails");
/**
 * @author Tomáš Leity
 */


var WindowAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(WindowAppModule, _AppModule_1$AppModul);

  function WindowAppModule() {
    var _this;

    _classCallCheck(this, WindowAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'windowAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(WindowAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(WindowConverter_1.WindowConverter).to(WindowConverterImpl_1.WindowConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(DataObjectConverter_1.DataObjectConverter, {
        className: Window_1.Window.name
      }).to(WindowConverterImpl_1.WindowConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowFilterConverter_1.WindowFilterConverter).to(WindowFilterConverterImpl_1.WindowFilterConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowOverviewFilterConverter_1.WindowOverviewFilterConverter).to(WindowOverviewFilterConverterImpl_1.WindowOverviewFilterConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowDerivedDataConverter_1.WindowDerivedDataConverter).to(WindowDerivedDataConverterImpl_1.WindowDerivedDataConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowUpdateDTOConverter_1.WindowUpdateDTOConverter).to(WindowUpdateDTOConverterImpl_1.WindowUpdateDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowItemConverter_1.WindowItemConverter).to(WindowItemConverterImpl_1.WindowItemConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowItemForecastChangeConverter_1.WindowItemForecastChangeConverter).to(WindowItemForecastChangeConverterImpl_1.WindowItemForecastChangeConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(DataObjectConverter_1.DataObjectConverter, {
        className: WindowItemForecastChange_1.WindowItemForecastChange.name
      }).to(WindowItemForecastChangeConverterImpl_1.WindowItemForecastChangeConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowItemProductSuppliersConverter_1.WindowItemProductSuppliersConverter).to(WindowItemProductSuppliersConverterImpl_1.WindowItemProductSuppliersConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(DataObjectConverter_1.DataObjectConverter, {
        className: WindowItem_1.WindowItem.name
      }).to(WindowItemConverterImpl_1.WindowItemConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(DataObjectConverter_1.DataObjectConverter, {
        className: WindowProductDetails_1.WindowProductDetails.name
      }).to(WindowProductDetailsConverterImpl_1.WindowProductDetailsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowItemSitesDataConverter_1.WindowItemSitesDataConverter).to(WindowItemSitesDataConverterImpl_1.WindowItemSitesDataConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowOverviewDTOConverter_1.WindowOverviewDTOConverter).to(WindowOverviewDTOConverterImpl_1.WindowOverviewDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowItemUpdateDTOConverter_1.WindowItemUpdateDTOConverter).to(WindowItemUpdateDTOConverterImpl_1.WindowItemUpdateDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowTypeConverter_1.WindowTypeConverter).to(WindowTypeConverterImpl_1.WindowTypeConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(DummyWindowConverter_1.DummyWindowConverter).to(DummyWindowConverterImpl_1.DummyWindowConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(DummyWindowInfoDTOConverter_1.DummyWindowInfoDTOConverter).to(DummyWindowInfoDTOConverterImpl_1.DummyWindowInfoDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(DummyWindowSimulationParamsConverter_1.DummyWindowSimulationParamsConverter).to(DummyWindowSimulationParamsConverterImpl_1.DummyWindowSimulationParamsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(DummyWindowSimulationSessionConverter_1.DummyWindowSimulationSessionConverter).to(DummyWindowSimulationSessionConverterImpl_1.DummyWindowSimulationSessionConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowActionContextConverter_1.WindowActionContextConverter).to(WindowActionContextConverterImpl_1.WindowActionContextConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowImportResultConverter_1.WindowImportResultConverter).to(WindowImportResultConverterImpl_1.WindowImportResultConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowImportErrorConverter_1.WindowImportErrorConverter).to(WindowImportErrorConverterImpl_1.WindowImportErrorConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowImportWindowIdentificationConverter_1.WindowImportWindowIdentificationConverter).to(WindowImportWindowIdentificationConverterImpl_1.WindowImportWindowIdentificationConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowCopyResultDTOConverter_1.WindowCopyResultDTOConverter).to(WindowCopyResultDTOConverterImpl_1.WindowCopyResultDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowMoveResultDTOConverter_1.WindowMoveResultDTOConverter).to(WindowMoveResultDTOConverterImpl_1.WindowMoveResultDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowFileConverter_1.WindowFileConverter).to(WindowFileConverterImpl_1.WindowFileConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowFileOverviewDTOConverter_1.WindowFileOverviewDTOConverter).to(WindowFileOverviewDTOConverterImpl_1.WindowFileOverviewDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowStatusConverter_1.WindowStatusConverter).to(WindowStatusConverterImpl_1.WindowStatusConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PromoDistributionModelConverter_1.PromoDistributionModelConverter).to(PromoDistributionModelConverterImpl_1.PromoDistributionModelConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowItemSimulationConverter_1.WindowItemSimulationConverter).to(WindowItemSimulationConverterImpl_1.WindowItemSimulationConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowItemSimulationSupplierDTOConverter_1.WindowItemSimulationSupplierDTOConverter).to(WindowItemSimulationSupplierDTOConverterImpl_1.WindowItemSimulationSupplierDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowSimulationConverter_1.WindowSimulationConverter).to(WindowSimulationConverterImpl_1.WindowSimulationConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SimulationBigNumberConverter_1.SimulationBigNumberConverter).to(SimulationBigNumberConverterImpl_1.SimulationBigNumberConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SimulationStringConverter_1.SimulationStringConverter).to(SimulationStringConverterImpl_1.SimulationStringConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowItemPromoPriceDTOConverter_1.WindowItemPromoPriceDTOConverter).to(WindowItemPromoPriceDTOConverterImpl_1.WindowItemPromoPriceDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowItemTransferValidationDTOConverter_1.WindowItemTransferValidationDTOConverter).to(WindowItemTransferValidationDTOConverterImpl_1.WindowItemTransferValidationDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SupplierAgreementTransferValidationDTOConverter_1.SupplierAgreementTransferValidationDTOConverter).to(SupplierAgreementTransferValidationDTOConverterImpl_1.SupplierAgreementTransferValidationDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(CoordinatorFlagsConverter_1.CoordinatorFlagsConverter).to(CoordinatorFlagsConverterImpl_1.CoordinatorFlagsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowItemPosAttributesConverter_1.WindowItemPosAttributesConverter).to(WindowItemPosAttributesConverterImpl_1.WindowItemPosAttributesConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(MemberCreditsConverter_1.MemberCreditsConverter).to(MemberCreditsConverterImpl_1.MemberCreditsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowItemPOSPriceRecalcInputConverter_1.WindowItemPOSPriceRecalcInputConverter).to(WindowItemPOSPriceRecalcInputConverterImpl_1.WindowItemPOSPriceRecalcInputConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowItemPlacementConverter_1.WindowItemPlacementConverter).to(WindowItemPlacementConverterImpl_1.WindowItemPlacementConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PromotionOverviewDTOConverter_1.PromotionOverviewDTOConverter).to(PromotionOverviewDTOConverterImpl_1.PromotionOverviewDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowItemHistoryTableConverter_1.WindowItemHistoryTableConverter).to(WindowItemHistoryTableConverterImpl_1.WindowItemHistoryTableConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(WindowSearchIndexConverter_1.WindowSearchIndexConverter).to(WindowSearchIndexConverterImpl_1.WindowSearchIndexConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(DistributionExceptionConverter_1.DistributionExceptionConverter).to(DistributionExceptionConverterImpl_1.DistributionExceptionConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return WindowAppModule;
}(AppModule_1.AppModule);

exports.WindowAppModule = WindowAppModule;